module.exports = __webpack_public_path__ + "media/images/emblems/Lignerolle-coat_of_arms-143c9be247611a54953c3888ca3e26ef.svg";